export default __webpack_public_path__ + "static/media/melanie_tan.11ad2274.jpg";